module.exports = __webpack_public_path__ + "media/svg/distributeur-8cfb351b.svg";